<ami-dialog-message [setting]="message"></ami-dialog-message>
<ami-table-actions
  [settings]="table.settings"
  [data]="table.data"
  [actions]="table.actions"
  (action)="onReciveAction($event); onReciveActionHead($event)"
  [actionsHead]="table.actionsHead"
></ami-table-actions>

<ng-container *ngIf="showOpenGroupedSaleNote">
  <pg-grouped-sales-note
    (close)="showOpenGroupedSaleNote = false"
  ></pg-grouped-sales-note>
</ng-container>

<ami-dialog-confirm
  [setting]="confirmSettings"
  (confirmed)="actionConfirmed($event)"
></ami-dialog-confirm>


<div *ngIf="idDocument">
  <ami-detail-sale-note-dialog
  [idDocument]="idDocument"
  (onHideData)="idDocument=undefined"
  >
</ami-detail-sale-note-dialog>
</div>


<ng-container *ngIf="openCancellationDialog">
  <pg-cancel-sale-note-dialog
    (close)="openCancellationDialog = false"
    [row]="saleNoteToCancel"
  ></pg-cancel-sale-note-dialog>
</ng-container>


